module.exports = __webpack_public_path__ + "img/DefaultUserImg.a7acffaf.jpg";